module.exports = __webpack_public_path__ + "img/asphalted_and_unstabilized.3e53aaf7.png";